import { createFileRoute } from "@tanstack/react-router";
import { buildSeo } from "@/lib/seo";
import { useTranslation } from "react-i18next";
import { MarketingLayout, I18nPageHero } from "@/components/marketing/Layout";

export const Route = createFileRoute("/dpa")({
  head: () =>
    buildSeo({
      path: "/dpa",
      title: "Data Processing Addendum (DPA) — Reality Twin Network",
      description:
        "Reality Twin Network's Data Processing Addendum, list of sub-processors and Standard Contractual Clauses.",
    }),
  component: DPAPage,
});

function DPAPage() {
  const { t } = useTranslation();
  const pre = t("routes.dpa.sectionsPre", { returnObjects: true }) as {
    h2: string;
    body: string;
  }[];
  const post = t("routes.dpa.sectionsPost", { returnObjects: true }) as {
    h2: string;
    body: string;
  }[];
  const headers = t("routes.dpa.spHeaders", { returnObjects: true }) as {
    name: string;
    purpose: string;
    region: string;
  };
  const subProcessors = t("routes.dpa.subProcessors", { returnObjects: true }) as {
    name: string;
    purpose: string;
    region: string;
  }[];
  return (
    <MarketingLayout>
      <I18nPageHero tKey="pages.dpa" />
      <div className="mx-auto max-w-3xl px-6 pt-20 text-[15.5px] leading-[1.7] text-muted-foreground">
        {pre.map((s) => (
          <div key={s.h2} className="mb-8">
            <h2 className="font-serif text-[28px] text-foreground mb-3 tracking-[-0.025em]">
              {s.h2}
            </h2>
            <p
              className="[&_a]:underline [&_a]:text-foreground"
              dangerouslySetInnerHTML={{ __html: s.body }}
            />
          </div>
        ))}
      </div>

      <div className="mx-auto max-w-3xl px-6 pb-12">
        <div className="hairline rounded-xl overflow-x-auto">
          <table className="w-full text-[14px] min-w-[560px]">
            <thead className="bg-cream">
              <tr className="border-b border-border">
                <th className="text-left font-medium px-5 py-3">{headers.name}</th>
                <th className="text-left font-medium px-5 py-3">{headers.purpose}</th>
                <th className="text-left font-medium px-5 py-3">{headers.region}</th>
              </tr>
            </thead>
            <tbody>
              {subProcessors.map((s) => (
                <tr key={s.name} className="border-b border-border last:border-b-0">
                  <td className="px-5 py-3 font-medium">{s.name}</td>
                  <td className="px-5 py-3 text-muted-foreground">{s.purpose}</td>
                  <td className="px-5 py-3 text-muted-foreground">{s.region}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mx-auto max-w-3xl px-6 pb-20 text-[15.5px] leading-[1.7] text-muted-foreground">
        {post.map((s) => (
          <div key={s.h2} className="mb-8">
            <h2 className="font-serif text-[28px] text-foreground mb-3 tracking-[-0.025em]">
              {s.h2}
            </h2>
            <p
              className="[&_a]:underline [&_a]:text-foreground"
              dangerouslySetInnerHTML={{ __html: s.body }}
            />
          </div>
        ))}
      </div>
    </MarketingLayout>
  );
}
